const GA = 'UA-4657551-1';
const GTM = 'GTM-KDCZBD';

const apiKeys = {
  GA,
  GTM,
};

export default apiKeys;
